module.exports = __webpack_public_path__ + "img/cartotrade.b87f8e21.svg";